import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import ImageGallery from "react-image-gallery"
import styled from "@emotion/styled"
import "./image-gallery.css"

const ImageGalleryWrapper = styled.div`
  width:100%;
  max-width:          1200px;
  max-height:         900px;
  padding:            16px 0px 16px 0px;
  margin:             16px;
  text-align:         center;
  margin: 0.8rem        auto;
  & .imagen-en-carrousel {
  height: 40vh;
  margin-top:auto;
  margin-bottom: auto;
  }
  & .imagen-en-carrousel .image-gallery-image {
    height: 40vh;
    margin-top:auto;
    margin-bottom: auto;
    object-fit: contain;
  }
  & .imagen-en-carrousel:focus {
    outline: none;
  }
  & .fullscreen .imagen-en-carrousel {
    height: 92vh;
  }
  & .fullscreen .imagen-en-carrousel .image-gallery-image {
    height: 92vh;
  }
  & .imagen-en-carrousel .image-gallery-description {
    width: 100%;
    background-color: #00000000;
    bottom: 0;
    font-family: Satisfy;
    font-size: 15px;
    padding: 0;
    padding-bottom: 16px;
    color: rgb(253,253,214);
    text-shadow: 2px 2px 4px black,  0 0 1em black, 0 0 0.2em black;
  }
  & .fullscreen .imagen-en-carrousel .image-gallery-description {
    bottom: 10px;
  }
  & .image-gallery-svg: {
    height: 60px;
    width: 30px;
  }
  & .image-gallery-icon: {
    color: #ffffff80;
    z-index=-1;
    opacity: 1;
  }
  & .image-gallery-content.fullscreen {
    top: 5vh;
  }
  & .image-gallery-content.fullscreen.left .image-gallery-slide .image-gallery-image, 
  .image-gallery-content.fullscreen.right .image-gallery-slide .image-gallery-image {
    max-height: 100vh;
  }
  & .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
  }
`

class FotosYCarrousel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: false,
      infinite: true,
      showIndex: props.lista.length > 1,
      showBullets: props.lista.length > 1,
      showThumbnails: props.lista.length > 1,
      showFullscreenButton: props.lista.length > 1,
      showGalleryFullscreenButton: props.lista.length > 1,
      showPlayButton: props.lista.length > 1,
      showGalleryPlayButton: props.lista.length > 1,
      showNav: props.lista.length > 1,
      isRTL: false,
      slideDuration: 450,
      slideInterval: 5000,
      slideOnThumbnailOver: false,
      thumbnailPosition: "left",
      showVideo: {},
    }

    // this.imagenesModoGatsby = this.props.lista.map(item => {
    //   console.log(item)
    //   return ({
    //   original: item.original,
    //   description: item.description,
    //   embedUrl: item.node.mbdurl,
    //   originalClass: 'imagen-en-carrousel',
    //   originalTitle: item.node.dscrpt,
    //   fluid: item.node.origen.childImageSharp.fluid,
    //   renderItem: item.node.mbdurl
    //     ? this._renderVideo.bind(this)
    //     : this._renderGatsbyImage.bind(this),
    // })})

    this.imagenesModoGatsby = this.props.lista.map(item => ({
      ...item,
      renderItem: item.mbdurl
        ? this._renderVideo.bind(this)
        : this._renderGatsbyImage.bind(this),
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.slideInterval !== prevState.slideInterval ||
      this.state.slideDuration !== prevState.slideDuration
    ) {
      // refresh setInterval
      this._imageGallery.pause()
      this._imageGallery.play()
    }
  }
  _onImageClick(event) {
    // console.debug(
    //   'clicked on image',
    //   event.target,
    //   'at index',
    //   this._imageGallery.getCurrentIndex(),
    // )
  }
  _onImageLoad(event) {
    // console.debug('loaded image', event.target.src)
  }

  _onSlide(index) {
    this._resetVideo()
    // console.debug('slid to index', index)
  }

  _onPause(index) {
    // console.debug('paused on index', index)
  }

  _onScreenChange(fullScreenElement) {
    // console.debug('isFullScreen?', !!fullScreenElement)
  }

  _onPlay(index) {
    // console.debug('playing from index', index)
  }

  _handleInputChange(state, event) {
    this.setState({ [state]: event.target.value })
  }

  _handleCheckboxChange(state, event) {
    this.setState({ [state]: event.target.checked })
  }

  _handleThumbnailPositionChange(event) {
    this.setState({ thumbnailPosition: event.target.value })
  }

  _resetVideo() {
    this.setState({ showVideo: {} })
    if (this.state.showPlayButton) {
      this.setState({ showGalleryPlayButton: true })
    }

    if (this.state.showFullscreenButton) {
      this.setState({ showGalleryFullscreenButton: true })
    }
  }

  _toggleShowVideo(url) {
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.showVideo[url] = !Boolean(this.state.showVideo[url])
    this.setState({
      showVideo: this.state.showVideo,
    })

    if (this.state.showVideo[url]) {
      if (this.state.showPlayButton) {
        this.setState({ showGalleryPlayButton: false })
      }

      if (this.state.showFullscreenButton) {
        this.setState({ showGalleryFullscreenButton: false })
      }
    }
  }

  _renderVideo(item) {
    return (
      <div>
        {this.state.showVideo[item.embedUrl] ? (
          <div className="video-wrapper">
            <button
              className="close-video"
              onClick={this._toggleShowVideo.bind(this, item.embedUrl)}
            ></button>
            <iframe
              title={item.embedUrl}
              src={item.embedUrl}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        ) : (
          <button onClick={this._toggleShowVideo.bind(this, item.embedUrl)}>
            <div className="play-button"></div>
            {console.log(item)}
            <img alt="" className="image-gallery-image" src={item.original} />
            {/* <Img className="image-gallery-image" objectFit="contain" fluid={item.fluid} /> */}
            {item.description && (
              <span
                className="image-gallery-description"
                style={{ right: "0", left: "initial" }}
              >
                {item.description}
              </span>
            )}
          </button>
        )}
      </div>
    )
  }

  _renderGatsbyImage(item) {
    return (
      <div>
        <Img
          className="image-gallery-image"
          objectFit="contain"
          fluid={item.fluid}
        />
        {item.description && (
          <span
            className="image-gallery-description"
            style={{ right: "0", left: "initial" }}
          >
            {item.description}
          </span>
        )}
      </div>
    )
  }
  // <iframe
  //   width="560"
  //   height="315"
  //   src="https://www.youtube.com/embed/6Fk0Mx1n3dQ"
  //   frameBorder="0"
  //   allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  //   allowFullScreen>
  // </iframe>
  // <iframe
  //   width="560"
  //   height="315"
  //   src="https://www.youtube.com/embed/LdH1hSWGFGU"
  //   frameBorder="0"
  //   allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  //   allowFullScreen>
  // </iframe>

  // {
  //   thumbnail: `${PREFIX_URL}4v.jpg`,
  //   original: `${PREFIX_URL}4v.jpg`,
  //   embedUrl: 'https://www.youtube.com/embed/4pSzhZ76GdM?autoplay=1&showinfo=0',
  //   description: 'Render custom slides within the gallery',
  //   renderItem: this._renderVideo.bind(this)
  // },
  render() {
    // const handleGoTo = index => {
    //   this.setState({ checked: true })
    //   this._imageGallery && this._imageGallery.slideToIndex(index)
    // }

    return (
      <div>
        <ImageGalleryWrapper>
          <ImageGallery
            ref={i => (this._imageGallery = i)}
            // items={this.images}
            items={this.imagenesModoGatsby}
            lazyLoad={false}
            onClick={this._onImageClick.bind(this)}
            onImageLoad={this._onImageLoad}
            onSlide={this._onSlide.bind(this)}
            onPause={this._onPause.bind(this)}
            onScreenChange={this._onScreenChange.bind(this)}
            onPlay={this._onPlay.bind(this)}
            infinite={this.state.infinite}
            showBullets={this.state.showBullets}
            showFullscreenButton={
              this.state.showFullscreenButton &&
              this.state.showGalleryFullscreenButton
            }
            showPlayButton={
              this.state.showPlayButton && this.state.showGalleryPlayButton
            }
            showThumbnails={this.state.showThumbnails}
            showIndex={this.state.showIndex}
            showNav={this.state.showNav}
            isRTL={this.state.isRTL}
            thumbnailPosition={this.state.thumbnailPosition}
            slideDuration={parseInt(this.state.slideDuration)}
            slideInterval={parseInt(this.state.slideInterval)}
            slideOnThumbnailOver={this.state.slideOnThumbnailOver}
            additionalClass="app-image-gallery"
          />
        </ImageGalleryWrapper>
      </div>
    )
  }
}
export default FotosYCarrousel
